import logo200Image from '../assets/img/logo/logo_2.png';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import Typography from '../components/Typography';
import axios from 'axios';

class ForgotPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    const data = {
      app_key: process.env.REACT_APP_KEY,
      email: this.state.email,
      redirect_url: '/set-password',
    };

    const self = this;
    const url = process.env.REACT_APP_API_URL;

    axios
      .post(url + ':3000/v1/user/forgot-password', data)
      .then(response => {
        const result = response.data;
        console.log(result);
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        alert(
          'An email will be sent to your mailbox to reset your password. Redirecting you to login page.',
        );
        self.props.history.push('/login');
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    const {
      usernameLabel,
      usernameInputProps,
      children,
      onSubmitClick,
    } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <div className="text-left pb-4">
          <img
            src={logo200Image}
            className="mb-3 d-block d-lg-none"
            style={{ width: 40, height: 40, cursor: 'pointer' }}
            alt="logo"
            onClick={onSubmitClick}
          />
          <Typography className="mb-5 h2">Forgot Password</Typography>
        </div>
        <FormGroup>
          <Label for={usernameLabel}>{usernameLabel}</Label>
          <Input
            {...usernameInputProps}
            value={this.state.email}
            onChange={this.changeHandler}
            required
          />
        </FormGroup>
        <hr />
        <Button
          color="link"
          size="lg"
          className="theme-button-primary border-0"
          block
          type="submit"
        >
          Confirm
        </Button>
      </Form>
    );
  }
}

ForgotPasswordForm.propTypes = {
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  onSubmitClick: PropTypes.func,
};

ForgotPasswordForm.defaultProps = {
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
    name: 'email',
  },
  onSubmitClick: () => {},
};

export default ForgotPasswordForm;
